import { useAppDispatch } from 'src/hooks';
import React, { useEffect, useRef, useState } from 'react';
import { Checkbox } from '@mui/material';
import { Row } from '@tanstack/table-core';
import _ from 'lodash';
import { TableComponent, Header } from '../../types/generic-table.model';
import { handleBooleanInputValueChange } from '../../../common/features/table/store/table-slice';

export default function CheckboxInput({
  row,
  columnMetadata,
  uniqueIDColumns,
  componentType = TableComponent.PRICING,
  inputsDisabled
}: {
  row: Row<{ [key: string]: any; }>,
  columnMetadata: Header;
  uniqueIDColumns: Header[];
  componentType: TableComponent;
  inputsDisabled: boolean
}) {
  const appDispatch = useAppDispatch();
  const [value, setValue] = useState(
    row.original[columnMetadata.parent.parent_field]
  );
  const previousValueRef = useRef<number>();
  const previousValue = previousValueRef.current;
  // When value is changed externally
  if (
    row.original[columnMetadata.parent.parent_field] !== previousValue &&
    row.original[columnMetadata.parent.parent_field] !== value
  ) {
    setValue(row.original[columnMetadata.parent.parent_field]);
  }

  const handleValueChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    const rowIndices: number[] = [];
    let currentRow = row;
    let parentRow = currentRow.getParentRow();
    while (!_.isEmpty(parentRow)) {
      rowIndices.unshift(currentRow.index);
      currentRow = parentRow;
      parentRow = currentRow.getParentRow();
    }
    setValue(checked ? 1 : 0);
    // Updating row model
    appDispatch(
      handleBooleanInputValueChange({
        columnMetadata,
        uniqueIDColumns,
        rowIndices: rowIndices.reverse(),
        newValue: checked ? 1 : 0,
        dataRow: row.original,
        isRowCanExpand: row.getCanExpand(),
        depth: row.depth
      })
    );
  };

  useEffect(() => {
    previousValueRef.current = row.original[columnMetadata.parent.parent_field];
  });

  return (
    <Checkbox
      checked={value === 1}
      value={value === 1}
      onChange={handleValueChange}
      size='small'
      placeholder='-'
      disabled={inputsDisabled}
    />
  );
}
